import { createSlice } from '@reduxjs/toolkit'

export interface HelpState {
  hasDisplayedHelpMessage: boolean
  hasClickedCloseHelpMessage: boolean
}

const initialState: HelpState = {
  hasDisplayedHelpMessage: false,
  hasClickedCloseHelpMessage: false,
}

const helpSlice = createSlice({
  name: 'help',
  initialState: initialState,
  reducers: {
    displayHelpMessage: state => {
      state.hasDisplayedHelpMessage = true
    },
    closeHelpMessage: state => {
      state.hasClickedCloseHelpMessage = true
    },
  },
})

export const { actions: helpActions, reducer: helpReducer } = helpSlice
export default helpSlice
